import { Component, OnInit } from '@angular/core';
import { MedicalConditionsVaccinesService } from './medical-conditions-vaccines.service';
import { MedicalConditionsVaccinesModel } from '../../../models/master-data/medical-conditions-vaccines.model';
import { AppMessages } from '../../../shared/constants/messages';
import { AppConstants } from '../../../shared/constants/constants';
import { Utility } from '../../../common/utility';
import { DialogService } from '../../../shared/services/dialog.service';
import { FormGroup } from '@angular/forms';
import { AddNewMedicalConditionVaccineComponent } from './add-new-medical-condition-vaccine-popup.component';
import { TMBDataTableComponent } from '../../../components/data-table/data-table.component';
import { SharedService } from '../../../shared/services/share.services';

@Component({
    selector: 'medical-conditions-vaccines',
    templateUrl: 'medical-conditions-vaccines-list.component.html',
    providers: [MedicalConditionsVaccinesService]
})

export class MedicalConditionsVaccinesComponent extends TMBDataTableComponent implements OnInit {
    dataRow = new Array<MedicalConditionsVaccinesModel>();

    medicalConditionsVaccinesList: FormGroup;
    filterData = {
        medicalCondition: '',
        medicalConditionName: '',
        vaccineName: ''
    };
    medicalConditions: any;

    constructor(
        public dialogService: DialogService,
        public sharedService: SharedService,
        public utility: Utility,
        private medicalConditionsVaccinesService: MedicalConditionsVaccinesService) {
            super(sharedService);
        }

    ngOnInit() {
        this.medicalConditionsVaccinesService.getMedicalCondition().subscribe(
            (result) => {
                if (result) {
                    const data = result.json();
                    this.medicalConditions = data;
                    // set default filter is first element list
                    if (this.medicalConditions.length > 0) {
                        this.filterData.medicalCondition = this.medicalConditions[0].id;
                        this.filterData.medicalConditionName = this.medicalConditions[0].name;
                    }
                    this.setPage({ offset: 0 });
                }
            },
            error => {
            }
        );
     }

     setPage(pageInfo) {
        this.page.pageNumber = pageInfo.offset;
        const param = {
            MedicalConditionId: this.filterData.medicalCondition === 'null' ? '' : this.filterData.medicalCondition,
            pageSize: this.page.size,
            currentPage: this.page.pageNumber + 1,
            vaccineName: this.filterData.vaccineName
        };

        this.medicalConditionsVaccinesService.getVaccineByMedicalCondition(param).subscribe(
            (result) => {
                if (result) {
                    const data = result.json();
                    this.dataRow = data['list'];
                    this.page.pageNumber = pageInfo.offset;
                    this.page.totalElements = data['totalRecords'];
                }
            },
            error => {
            }
        );
    }

    onFilter() {
        this.setPage({ offset: 0 });
    }

    onMedicalConditionCategoryChange() {
        this.filterData.vaccineName = '';
        this.medicalConditions.forEach(item => {
            if (item.id === this.filterData.medicalCondition) {
                this.filterData.medicalConditionName = item.name;
            }
        });
        this.setPage({ offset: 0 });
    }

    onRemoveItem(id) {
      this.dialogService.openConfirmationDialog({message: AppMessages.diseasesVaccine.removeDiseasesVaccine}).subscribe(
        (result) => {
            if (result) {
                this.medicalConditionsVaccinesService.deleteMedicalConditionVaccine(this.filterData.medicalCondition,id).subscribe(
                  deleteResult => {
                    if (deleteResult) {
                      this.reloadPage(this.page.pageNumber, this.dataRow, true);
                    }
                  }
                );
              }
      });
    }

    addNewMedicalCondition(): void {
        const data = {
            medicalConditionId: this.filterData.medicalCondition,
            medicalConditionName: this.filterData.medicalConditionName,
            dataList: this.dataRow
        };
        this.dialogService.openComponentDialog(AddNewMedicalConditionVaccineComponent,
            data).subscribe(
                (result) => {
                    if (result) {
                      this.reloadPage(this.page.pageNumber, this.dataRow);
                    }
                });
    }

}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/master-data/medical-conditions-vaccines/medical-conditions-vaccines-list.component.ts